import React, { useCallback, useEffect, useState } from 'react';

import { useUserInfo, useLocalStorage } from '../../../../hooks';
import { HoSelectBox, StepSelectBox } from './selectBox';
import {
  aiBarosamSearchHistoryReg,
  aiBarosamSearchHistorySel
} from '../../../../api/progressLearningAPI';

function SelectForm({ onSearch }) {

  const [stepCode, setSetpCode] = useState('');
  const [hoCode, setHoCode] = useState('');
  const { info } = useUserInfo();
  const { userData, setUserData } = useLocalStorage();

  useEffect( () => {
    const p = userData.gmmp;
    if (p) {
      aiBarosamSearchHistoryRegCall({
        brsStepCd: p?.brsStepCd,
        brsEditionCd: p?.brsEditionCd
      }, p);

      setUserData({gmmp: null});
    } else {
      aibarosemSearchHistory();
    }
    

  }, []);

  const aibarosemSearchHistory = useCallback(async () => {
    const resp = await aiBarosamSearchHistorySel({ type: 'step', lrnMbrId: info.learnerId });
    if (resp) {
      const code = resp.split(";");

      if (code && code.length === 2) {
        setSetpCode(code[0]);
        setHoCode(code[1]);

        onSearch({
          brsStepCd: code[0],
          brsEditionCd: code[1],
          lrnMbrId: info.learnerId,
          language: info.locale,
        });
      }
    }
  }, [])

  const aiBarosamSearchHistoryRegCall = useCallback(async ({
    brsStepCd, brsEditionCd
  }, p) => {
    await aiBarosamSearchHistoryReg({
      type: 'step',
      lrnMbrId: info.learnerId,
      data: `${brsStepCd};${brsEditionCd}`
    });

    if (p) {
      aibarosemSearchHistory();
    }
  }, []);


  const handleCodeSet = (type, code) => {
    if (type === 'step') {
      setSetpCode(code);
      setHoCode('');
    } else if (type === 'ho') {
      setHoCode(code);
      onSubmit(code);
    }

  }

  const onSubmit = async (pHoCode) => {
    const data = {
      "brsStepCd": stepCode,
      "brsEditionCd": pHoCode,
      "lrnMbrId": info.learnerId,
      "language": info.locale,
    };

    console.log("***** 진도학습 - 바로셈 진도 변경")

    await aiBarosamSearchHistoryRegCall({
      brsStepCd: data.brsStepCd,
      brsEditionCd: data.brsEditionCd
    });

    onSearch(data);
  }
  return (
    <div className="select_wrap">
      <StepSelectBox
        defaultValue={stepCode}
        handleCodeSet={handleCodeSet}
      />
      <HoSelectBox
        stepCode={stepCode}
        defaultValue={hoCode}
        handleCodeSet={handleCodeSet}
      />
      {/* <div className="area area3">
        <button
          className="btn btn-blue h48"
          onClick={onSubmit}
        >
          확인
        </button>
      </div> */}
    </div>
  );
}

export default SelectForm;